<template>
  <div>
    <WebHeaderView :title="$t('menu.bank')" />
    <div class="page-content">
      <van-sticky :offset-top="50">
      <van-tabs
        @click="tabClick"
        v-model="active"
        color="#fff"
        title-active-color="#fff"
      >
        <van-tab title="银行卡" :name="1" />
        <van-tab title="钱包" :name="2" />
      </van-tabs>
      </van-sticky>
      <div v-if="active == 1" class="bank-box">
        <div class="methods">
          <a class="addBank" @click="$router.push({ name: 'addbank' })"
            ><div class="icon"></div>
            <span class="title">添加银行卡</span></a
          >
        </div>
        <div class="card-list">
          <ul>
            <li
              v-for="(item, index) in banks"
              :key="index"
              style="text-align: left; margin-bottom: 10px"
            >
              <div class="card icbc">
                <div class="bank">
                  <p class="iconName">
                    <img :src="item.bank_img" alt="" class="bankIcon" />
                    <span class="bankName">{{ item.bank_name }}</span>
                  </p>
                </div>
                <p class="cardNum" style="padding-left: 20px">
                  {{ item.card_number }}
                </p>
                <p class="cardNum" style="padding-left: 20px">
                  {{ item.branch }}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="active == 2" class="bank-box">
        <ul>
          <li
            v-for="(item, index) in wallets"
            :key="index"
            style="text-align: left; margin-bottom: 10px"
          >
            <div class="card icbc">
              <div class="bank">
                <p class="iconName">
                  <img :src="item.logo" alt="" class="bankIcon" />
                  <span class="bankName">{{ item.name }}</span>
                </p>
              </div>
              <p class="cardNum" style="padding-left: 20px;overflow: hidden;">
                {{ item.address }}
              </p>
              <div
                style="
                  position: absolute;
                  top: 0px;
                  right: 10px;
                  height: 30px;
                  line-height: 30px;
                "
              >
                <span v-if="item.is_bind == 1">{{ item.is_bind }} / 1 </span>
                <span v-else @click="toBindWaller(item)">绑定</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="add-wallet">
      <van-popup v-model="walletshow" position="bottom" closeable round v-if="walletshow">
        <div>
          <div
            style="
              text-align: center;
              height: 38px;
              line-height: 38px;
              font-size: 18px;
              font-weight: 600;
              margin-top: 10px;
              color: #fff;
            "
          >
            绑定{{ wallet.name }}
          </div>
          <van-form ref="subfrm" @submit="bandWallet" style="text-align: left">
            <div class="add-wallet-frm">
              <van-cell-group>
                <van-cell :title="wallet.name">
                  <template #label>
                    <van-field
                      v-model="address"
                      :placeholder="'请输入'+wallet.name"
                      :rules="[{ required: true }]"
                    />
                  </template>
                </van-cell>
                <van-cell title="支付密码">
                  <template #label>
                    <van-field
                      v-model="pay_pass"
                      type="password"
                      placeholder="请输入支付密码"
                      :rules="[{ required: true }]"
                    />
                  </template>
                </van-cell>
              </van-cell-group>
            </div>
            <div style="margin: 16px">
              <van-button
                block
                native-type="submit"
                style="
                  background-color: #cca352;
                  color: #fff;
                  border-radius: 8px;
                  border-color: #cca352;
                "
                >绑定</van-button
              >
            </div>
          </van-form>
        </div>
      </van-popup>
    </div>
     <van-dialog
      v-model="showdialog"
      title="实名认证"
      show-cancel-button
      :showCancelButton="true"
      confirmButtonText="确认"
      cancelButtonText="返回"
      v-if="showdialog"
      @cancel="$router.back()"
      @confirm="onSubmit"
    >
      <van-form>
        <van-field
          v-model="username"
          label="真实姓名"
          placeholder="请填写真实姓名"
        />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
export default {
  name: 'BankView',
  components: {
    WebHeaderView
  },
  data () {
    return {
      active: 2,
      banks: [],
      wallets: [],
      walletshow: false,
      wallet: {},
      address: null,
      pay_pass: null,
      showdialog:false
    }
  },
  mounted () {
    this.getusrInf()
    this.GetBank()
    this.GetWallets()
    const query = this.$route.query
    if (query.type) {
      this.active = parseInt(query.type)
    }
  },
  methods: {
    async getusrInf () {
      await this.$http({
        method: 'post',
        url: 'usrInf'
      }).then(data => {
        if (!(data.data.realname && data.data.realname.length > 0)) {
          this.showdialog = true
        }
      })
    },
    async onSubmit () {
      if (!this.username) {
        this.$toast.fail('请填写真实姓名')
        setTimeout(() => {
          // location.reload()
          this.showdialog = true
        }, 1500)
        return
      }
      await this.$http({
        method: 'post',
        url: 'setName',
        data: {realname:this.username}
      }).then(data => {
       this.$toast.success(data)
       setTimeout(() => {
          location.reload()
        }, 1500)
      })
    },
    async bandWallet () {
      await this.$http({
        method: 'post',
        url: 'bindWallet',
        data: {
          id: this.wallet.id,
          address: this.address,
          pay_pass: this.pay_pass
        }
      }).then(data => {
        this.$toast.success(data.msg)
        this.GetWallets()
        this.walletshow = false
        this.wallet = {}
      })
    },
    toBindWaller (item) {
      this.wallet = item
      this.walletshow = true
      this.address = null
      this.pay_pass = null
      this.$refs.subfrm.resetValidation()
    },
    tabClick (val) {
      this.active = val
    },
    async GetBank () {
      await this.$http({
        method: 'post',
        url: 'getBank'
      }).then(data => {
        this.banks = data.data
      })
    },
    async GetWallets () {
      await this.$http({
        method: 'post',
        url: 'getWallet'
      }).then(data => {
        this.wallets = data.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bank-box {
  width: 94%;
  margin: 10px auto 0;
  height: calc(100vh - 110px);
  position: relative;
  font-size: 14px;
  .methods {
    position: fixed;
    left: 0;
    bottom: 45px;
    width: 90%;
    left: 5%;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    padding: 15px 0;
    background-color: #282828;
    border-radius: 10px;
    a.addBank {
      text-align: center;
      .icon {
        width: 61px;
        height: 60.5px;
        margin: 10px auto;
        background-image: url('../../assets/images/account.png');
        background-repeat: no-repeat;
        background-position: -56.5px -84.5px;
        background-size: 267.5px 145px;
      }
    }
  }
  .card-list {
    width: 100%;
    height: calc(100vh - 280px);
    overflow: auto;
  }
}
.card {
  position: relative;
  padding: 15px;
  color: #fff;
  background-color: #282828;
  border-radius: 10px;
  .iconName {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    max-width: 415px;
  }

  .bankIcon {
    width: 30px;
  }
  .bankName {
    margin-left: 10px;
    font-size: 16px;
  }
  .cardNum {
    padding-bottom: 2px;
    padding-top: 10px;
    margin-top: 0px;
    font-size: 20px;
  }
}
.icbc {
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#fe7e66),
    to(#cc3d55)
  );
  background: linear-gradient(90deg, #fe7e66, #cc3d55);
}
</style>
<style>
.add-wallet > .van-popup {
  background: #282828 !important;
}
.add-wallet-frm > .van-cell-group > .van-cell {
  background: #282828 !important;
}
.add-wallet-frm > .van-cell-group > .van-cell::after {
  border: none;
}
.add-wallet-frm
  > .van-cell-group
  > .van-cell
  > .van-cell__title
  > .van-cell__label
  > .van-cell {
  background: #282828 !important;
}
.add-wallet-frm > .van-cell-group > .van-cell > .van-cell__title {
  color: #fff !important;
}
.add-wallet-frm
  > .van-cell-group
  > .van-cell
  > .van-cell__title
  > .van-cell__label
  > .van-cell
  > .van-cell__value
  > .van-field__body
  > input.van-field__control {
  color: #fff !important;
}
</style>
